module.exports = __webpack_public_path__ + "static/media/visa.6af8843b.svg";